import React from 'react'
import styled from 'styled-components'
import VisaImage from '../../../../assets/img/visa_icon.png'
import PaypalImage from '../../../../assets/img/paypal_icon.png'
import MastercardImage from '../../../../assets/img/mastercard_icon.png'
import PagoEfectivoImage from '../../../../assets/img/pagoefectivo_icon.png'
import AmexImage from '../../../../assets/img/amex_icon.png'
import DinersImage from '../../../../assets/img/diners_icon.png'
import SafetyImage from '../../../../assets/img/safetypay_icon.png'

const ContainerPayments = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 50px auto;

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 25px 12px;
  }

  > div img{
    width: 80%;
  }
`

const listMethods = [
  {
    id: 1,
    icon: VisaImage
  },
  {
    id: 2,
    icon: PaypalImage
  },
  {
    id: 3,
    icon: MastercardImage
  },
  {
    id: 4,
    icon: PagoEfectivoImage
  },
  {
    id: 5,
    icon: AmexImage
  },
  {
    id: 6,
    icon: DinersImage
  },
  {
    id: 7,
    icon: SafetyImage
  },
]

const PaymentMethods: React.FunctionComponent = () => {
  return (
    <ContainerPayments>
        {listMethods.map(method => (
          <div>
            <img key={method.id} src={method.icon} alt='icons'/>
          </div>
        ))}
    </ContainerPayments>
  )
}

export default PaymentMethods